
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import OrderModule from "@/store/modules/order";
import ModalMixin from "./mixin";
import BarcodeOrderHeader from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderHeader.vue";
import BarcodeOrderItemTable from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderItemTable.vue";
import BarcodeNoScanLineItemTable from "@/components/barcodeSystem/barcodeOrder/BarcodeNoScanLineItemTable.vue";
import BarcodeOrderPalletTable from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderPalletTable.vue";
import { BarcodeOrderResource } from "@/models/api/barcodeSystem/barcodeOrders/get";
import notifications from "@/lib/notifications";
import BarcodeOrderStockPickingTable from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderStockPickingTable.vue";
import BarcodeOrderItemPickTable from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderItemPickTable.vue";
import BarcodeOrderDeliverySignatures from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderDeliverySignatures.vue";
import BarcodeOrderMap from "@/components/order/BarcodeOrderMap.vue";
import TransactionTable from "@/components/barcodeSystem/barcodeOrder/TransactionTable.vue"
import permissions from "@/security/permissions";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);
const orderModuleState = getModule(OrderModule);

@Component({
  name: modals.barcodeOrderViewModal,
  components: {
    BarcodeOrderHeader,
    BarcodeOrderItemTable,
    BarcodeNoScanLineItemTable,
    BarcodeOrderPalletTable,
    BarcodeOrderStockPickingTable,
    BarcodeOrderItemPickTable,
    BarcodeOrderDeliverySignatures,
    BarcodeOrderMap,
    TransactionTable
  }
})
export default class BarcodeOrderViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  tabIsLoading: boolean = false;
  loadedTabs: string[] = [];
  mapkey: number = 0;
  pins: any[] = [];
  mappablePins: any[] = [];
  selectedPinIndex: any = -1;
  hasAnyGeoLocations: boolean = false;
  loadingTransactions: boolean = false;
  showTransLogsModal: boolean = false;
  transOrderItemId: number | null = null;
  transLogsLoaded: boolean = false;
  
  ORDER_ITEM_MENU_ITEM: any = [
    { title: "View Transactions", type: "viewTransactions", requiresPermission:permissions.barcodeSystem.orders.view, maxSelection:1},
    { title: "View Inventory Item", type: "viewInventoryItem", requiresPermission:permissions.barcodeSystem.inventory.view, maxSelection:1},
    { title: "Update Order Item", type: "updateItem", requiresPermission:permissions.barcodeSystem.orders.items.save, maxSelection:1}
  ];

  NO_SCAN_LINE_ITEM_MENU_ITEM: any = [
    { title: "Update Line Item", type: "updateItem", requiresPermission:permissions.barcodeSystem.orders.noScanLineItems.save, maxSelection:1},
    { title: "Remove Line Item", type: "deleteItem", requiresPermission:permissions.barcodeSystem.orders.noScanLineItems.save, maxSelection:1}
  ];

  async load() {
    this.loadingComplete = false;
    this.show();
    try {
      await barcodeOrderModuleState.loadBarcodeOrder(this.selectedItem.id);  
    } catch (ex) {
      notifications.error("Failed to load order", "Failed to load barcode order.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
    this.loadTab("orderItems")
  }

  get orderItemCount() : number
  {
    if(barcodeOrderModuleState.currentBarcodeOrderItems)
      return barcodeOrderModuleState.currentBarcodeOrderItems.length;
    return 0
  }

  get currentBarcodeOrder() : BarcodeOrderResource
  {
    return barcodeOrderModuleState.currentBarcodeOrder;
  }

  get isAgentObject() : boolean
  {
    return barcodeOrderModuleState.currentBarcodeOrder ? barcodeOrderModuleState.currentBarcodeOrder.isAgentObject : false;
  }

  get requiresReceiving() : boolean
  {
    return this.currentBarcodeOrder ? this.currentBarcodeOrder.requiresReceiving : false;
  }

  get requiresDelivery() : boolean
  {
    return this.currentBarcodeOrder ? this.currentBarcodeOrder.requiresDelivery : false;
  }

  get requiresPicking() : boolean
  {
    return this.currentBarcodeOrder ? this.currentBarcodeOrder.requiresPicking : false;
  }

  get hasDeliverySignatures() : boolean
  {
    return this.currentBarcodeOrder ? this.currentBarcodeOrder.hasDeliverySignatures : false;
  }

  get isComplete() : boolean
  {
    return this.currentBarcodeOrder ? !this.currentBarcodeOrder.isOpen : false;
  }

  get orderId() : number | null
  {
    return this.currentBarcodeOrder ? this.currentBarcodeOrder.id : null;
  }

  async reloadOrder(){
    this.loadingComplete = false;
    try
    {
      await barcodeOrderModuleState.reloadBarcodeOrder();
      await barcodeOrderModuleState.loadBarcodeOrderItems(this.currentBarcodeOrder.id);      
      if(this.tabHasBeenLoaded("noScanLineItems"))
      {
        await barcodeOrderModuleState.loadBarcodeNoScanLineItems(this.currentBarcodeOrder.id);
      }   
      if(this.tabHasBeenLoaded("pallets"))
      {
        await barcodeOrderModuleState.loadBarcodeOrderPallets(this.currentBarcodeOrder.id);
      }      
      if(this.tabHasBeenLoaded("stock"))
      {
        await barcodeOrderModuleState.loadBarcodeOrderStockPickings(this.currentBarcodeOrder.id);
      }      
      if(this.tabHasBeenLoaded("unspecified"))
      {
        await barcodeOrderModuleState.loadBarcodeOrderItemPicks(this.currentBarcodeOrder.id);
      }    
      if(this.tabHasBeenLoaded("signatures"))
      {
        await barcodeOrderModuleState.loadBarcodeOrderDeliverySignatures(this.currentBarcodeOrder.id);
      }
      if(this.tabHasBeenLoaded("map"))
      {
        await this.loadMap(this.currentBarcodeOrder.id);
      }
      if(orderModuleState.currentOrder && orderModuleState.currentOrder.headerNumber.toString() == this.currentBarcodeOrder.orderNumber)
      {
        await orderModuleState.reloadOrderShortcutAction();
      }
    } catch (ex) {
      notifications.error("Failed to reload order", "Failed to reload barcode order.", ex);
    }
    this.loadingComplete = true;
  }

  async reloadOrderItems()
  {
    this.tabIsLoading = true;
    try {
      await barcodeOrderModuleState.loadBarcodeOrderItems(this.currentBarcodeOrder.id);
    } catch(error) {
        notifications.error("Error reloading items", `Failed to reload order items.`, error);
    } finally {
      this.tabIsLoading = false;
    }
  }

  async reloadNoScanLineItems()
  {
    this.tabIsLoading = true;
    try {
      await barcodeOrderModuleState.loadBarcodeNoScanLineItems(this.currentBarcodeOrder.id);
    } catch(error) {
        notifications.error("Error reloading items", `Failed to reload no scan line items.`, error);
    } finally {
      this.tabIsLoading = false;
    }
  }

  tabHasBeenLoaded(title: string): boolean {
    return this.loadedTabs.indexOf(title) > -1;
  }

  loadTab(title: string) {
    if (this.tabHasBeenLoaded(title)) {
      return;
    }

    let action = null;

    switch (title) {
      case "orderItems":
        action = barcodeOrderModuleState.loadBarcodeOrderItems;
        break;
      case "noScanLineItems":
        action = barcodeOrderModuleState.loadBarcodeNoScanLineItems;
        break;
      case "pallets":
        action = barcodeOrderModuleState.loadBarcodeOrderPallets;
        break;
      case "stock":
        action = barcodeOrderModuleState.loadBarcodeOrderStockPickings;
        break;
      case "unspecified":
        action = barcodeOrderModuleState.loadBarcodeOrderItemPicks;
        break;
      case "signatures":
        action = barcodeOrderModuleState.loadBarcodeOrderDeliverySignatures;
        break;
      case "map":
        action = this.loadMap;
        break;
    }
    if (action) {
      this.tabIsLoading = true;
      action(barcodeOrderModuleState.currentBarcodeOrder.id)
      .catch((error) => {
        notifications.error("Error loading tab", `Failed to load ${title} tab.`, error);
      })
      .finally(() => {
        this.loadedTabs.push(title);
        this.tabIsLoading = false;
      });
    }
  }

  reset() {
    this.transOrderItemId = null;
    this.transLogsLoaded = false;
    this.hasAnyGeoLocations = false;
    this.mapkey = 0;
    this.loadingComplete = false;
    this.tabIsLoading = false;
    this.loadedTabs = [];
  }

  viewOrder() {
    this.hideModal();
    orderModuleState.openOrderShortcutAction({selectedItems: [{number: this.currentBarcodeOrder.orderNumber}]})
  }

  showMap() {
    return this.mapkey > 0 && !this.tabIsLoading && this.hasAnyGeoLocations;
  }

  refreshMap() {
    this.mapkey += 1;
  }

  async loadMap(barcodeOrderId){
    await this.createPins();
    this.refreshMap();
  }

  async createPins() {
    var orderItems = barcodeOrderModuleState.currentBarcodeOrderItems;
    var locations = await barcodeOrderModuleState.getOrderItemGps(this.currentBarcodeOrder.id);

    this.pins = [];
    this.mappablePins = [];

    var ordinal = 1;
    for (let i = 0; i < orderItems.length; i++) {
      var orderItem = {
        id: orderItems[i].id,
        barcode: orderItems[i].itemScan,
        commodityCode: orderItems[i].itemName,
        quantity: orderItems[i].quantity,
        status: orderItems[i].status
      };

      var matchLocations = locations.filter(l => l.orderItemId == orderItem.id);
      if (matchLocations.length > 0) {
        this.hasAnyGeoLocations = true;
        var location = matchLocations[0];
        var matchPins = this.pins.filter(
          p => p.longitude == location.longitude && p.latitude == location.latitude
        );

        if (matchPins.length > 0) {
          matchPins[0].barcodes.push(orderItem);
        } else {
          var isValid = location.longitude != 0 || location.latitude != 0;
          var pin = {
            ordinal: ordinal,
            title: isValid ? `Location #${ordinal}` : "Unknown",
            longitude: location.longitude,
            latitude: location.latitude,
            barcodes: [orderItem]
          };
          if (isValid) {
            this.mappablePins.push(pin);
            ordinal++;
          }
          this.pins.push(pin);
        }
      }
    }
  }

  openPin(pinIndex) {
    this.selectedPinIndex = pinIndex;
  }

  async showTransLogs(orderItemId: number| null){
    this.transOrderItemId = orderItemId;
    if(!this.transLogsLoaded){
      this.loadingTransactions = true;
      try {
        await barcodeOrderModuleState.loadBarcodeOrderTransactions(this.currentBarcodeOrder.id);
        this.transLogsLoaded = true;
      } catch (error ) {
        notifications.error("Loading Transaction", "Failed to load order transactions.", error);
      } finally {
        this.loadingTransactions = false;
      }
    }
    if(this.transLogsLoaded) {
      this.showTransLogsModal = true;
    }
  }

  closeModals(){
    this.showTransLogsModal = false;
  }

  get orderItemMenuItemsToDisplay() {
    return this.ORDER_ITEM_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission, this.isAgentObject)
    );
  }  
  
  get noScanLineItemMenuItemsToDisplay() {
    return this.NO_SCAN_LINE_ITEM_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission, this.isAgentObject)
    );
  }
}
